import React, { useEffect } from "react";
import HomeBanner from "./HomeBanner/HomeBanner";
import AppsSection from "./AppsSection/AppsSection";
import FeaturesSection from "./FeaturesSection/FeaturesSection";
import ServersSection from "./ServersSection/ServersSection";
import PricingPlans from "./PricingPlans/PricingPlans";
import HowItWorks from "./HowItWorks/HowItWorks";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { GetUserDetails } from "../../../Helpers/Utility";
import { postData } from "../../../Services/Api";

export default function Home() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (searchParams.get("is_crypto_payment_success") == "true") checkStatus();
  }, [searchParams, pathname]);

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  const checkStatus = async () => {
    const userDetails = GetUserDetails();
    const txnId = getCookie("txn_id");
    if (userDetails?.token && !userDetails?.isAdmin && txnId) {
    const headers = {
      Authorization: `Bearer ${userDetails?.token}`,
    };

    const data = {
      txn_id: txnId,
    };
    const res = await postData("check-coin-payment-status", data, headers);
    eraseCookie("txn_id");
    res?.data?.message &&
      toast.info(
        res.data.message
      );
    navigate("/");
    }
  };
  return (
    <div className="HomeSection paddingRespo">
      <HomeBanner />
      <AppsSection />
      <FeaturesSection />
      <ServersSection />
      <PricingPlans />
      <HowItWorks />
    </div>
  );
}
